import type { Feature } from '@luna/gatekeeper';

export const expirationTime: Feature = {
    enabled: true,
    _description: 'Displays expiration time label in the debit card header',
};
